import { TODO } from '@b2b/types/core';
import uiRouter, { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService, IWindowService } from 'angular';
import { ApiService } from '@b2b/common/services/api/types';
import { MembershipDetails } from '@b2b/types/membership'; 

OrdersDetailFormsDetailController.$inject = [
  '$scope',
  '$state',
  '$timeout',
  '$window',
  '$filter',
  'HelpersService',
  'CalendarService',
  'ApiService',
  'ResponseData',
];

function OrdersDetailFormsDetailController(
  $scope: IScope & { ordersDetailFormsDetail: TODO },
  $state: StateService,
  $timeout: ITimeoutService,
  $window: IWindowService,
  $filter: IFilterService,
  HelpersService: TODO,
  CalendarService: TODO,
  ApiService: ApiService,
  ResponseData: TODO
) {
  const ctrl = {
    model: {} as TODO,
    filtered: {
      col1: [],
      col2: [],
    },

    vm: {
      formType: 'event',
      eventDate: '',
      displaySubmittedOn: '',
      membership: {} as MembershipDetails
    },

    init: function () {
      $scope.$emit('Application::contentTitleChange', {
        title: 'Form Response Details',
        buttonLeft: {
          label: 'Back',
          permissions: ['ORDER_VIEW'],
          action: function () {
            window.history.go(-1);
          },
        },
        buttonRight: {
          label: 'Edit Response',
          permissions: ['FORM_RESPONSE_UPDATE'],
          action: function () {
            ctrl.editResponse();
          },
        },
      });

      if (ResponseData.data && ResponseData.data.success) {
        ctrl.model = ResponseData.data.payload;
        ctrl.vm.eventDate = $filter('date')(
          CalendarService.parseDate(ctrl.model.eventStartTime),
          HelpersService.dateFormats.standardDateTime
        );

        ctrl.vm.formType = ctrl.model.formCategoryType;

        switch (ctrl.vm.formType) {
          case 'membership':
            ApiService.membership
              .detail(ctrl.model.membershipId)
              .then((res) => {
                ctrl.vm.membership = res.data.payload;
                // $scope.$apply();
              })
              .catch((res) => {
                console.log(res);
              });
            break;
          default:
            break;
        }
      }

      if (ctrl.model.formResponseData) {
        ctrl.vm.displaySubmittedOn = $filter('date')(
          CalendarService.parseDate(ctrl.model.formResponseData.submissionDate),
          HelpersService.dateFormats.shortDateTime
        );
        if (
          ctrl.model.formResponseData.hasOwnProperty('responseData') &&
          ctrl.model.formResponseData.responseData &&
          ctrl.model.formResponseData.responseData.hasOwnProperty('fields') &&
          ctrl.model.formResponseData.responseData.fields instanceof Array &&
          ctrl.model.formResponseData.responseData.fields.length
        ) {
          ctrl.processResponseData(ctrl.model.formResponseData.responseData.fields);
        }
      }
    },

    launchPrint: function () {
      const height = $(window).height();
      const width = $(window).width();

      const wHeight = height ? height - 20 : 0;
      const wWidth = width ? width - 20 : 0;

      // Open print window
      $timeout(function () {
        window.open(
          '/app/orders/' + $state.params.orderId + '/detail/forms/' + $state.params.responseId + '/print',
          'formResponseData',
          'height=' + wHeight + ',width=' + wWidth + ',left=10,scrollbars=yes,resizable=yes'
        );
        return;
      }, 10);
    },

    processResponseData: function (responseData) {
      var col1, col2;

      if (responseData.length % 2) {
        col1 = responseData.slice(0, Math.ceil(responseData.length / 2));
        col2 = responseData.slice(Math.floor(responseData.length / 2) + 1, responseData.length);
      } else {
        col1 = responseData.slice(0, Math.ceil(responseData.length / 2));
        col2 = responseData.slice(Math.floor(responseData.length / 2), responseData.length);
      }

      ctrl.filtered.col1 = col1;
      ctrl.filtered.col2 = col2;
    },

    editResponse: function () {
      $state.go('application.orders.detail.forms.edit', { responseId: $state.params.responseId });
    },
  };

  $scope.ordersDetailFormsDetail = ctrl;
  $scope.ordersDetailFormsDetail.init();
}

export const OrdersDetailFormsDetailModule = angular
  .module('acme.view.application.orders.detail.forms.detail.controllers', [
    uiRouter,
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.api',
  ])
  .controller('OrdersDetailFormsDetailController', OrdersDetailFormsDetailController).name;
